const config = {
  

  // Url ALPHA environment -----------------------
  // apiBaseUrl: "https://iot-openapi.yes.my/yesshop-admin-web/ws/v1/",

  // apiBaseUrlv2: "https://iot-openapi.yes.my/yesshop-admin-web/ws/v2/",

  // oAuthBaseUrl: "https://iot-apigateway.yes.my/api/v1/openid-connect/iot-ytlc-apigw/token",

  // // Other development-specific configuration variables
  // downloadReportBaseUrl: "https://iot-openapi.yes.my/yesshop-admin-web-report/ws/v1/",



// https://staging-openapi.yes.my/api/v1/openid-connect/staging-ytlc-apigw/token

// https://staging-openapi.yes.my/api/v2/openid-connect/ytlc-apigw/token

  // Url BETA environment -----------------------
  // apiBaseUrl: "https://staging-openapi.yes.my/yesshop-admin-web/ws/v1/",

  // apiBaseUrlv2: "https://staging-openapi.yes.my/yesshop-admin-web/ws/v2/",

  // oAuthBaseUrl: "https://staging-openapi.yes.my/api/v1/openid-connect/staging-ytlc-apigw/token",

  // // Other development-specific configuration variables
  // downloadReportBaseUrl: "https://staging-openapi.yes.my/yesshop-admin-web-report/ws/v1/",


   // New Url PDC -----------------------
   apiBaseUrl: "https://openapi.yes.my/yesshop-admin-web/ws/v1/",
 
   apiBaseUrlv2: "https://openapi.yes.my/yesshop-admin-web/ws/v2/",
 
   oAuthBaseUrl: "https://openapi.yes.my/api/v1/openid-connect/ytlc-apigw/token",
 
   // Other development-specific configuration variables
   downloadReportBaseUrl: "https://openapi.yes.my/yesshop-admin-web-report/ws/v1/",


};

export default config;
